import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import Processo from '../../../model/processo/Processo';
import { StatusCandidato } from '../../../model/Candidato/Candidato';

interface CandidatoOnlyResponse {
    id: string;
    candidatoEditais: CandidatoEditalResponse[];
    nome: string;
    nomeSocial: string | null;
    cpf: string;
    passaporte: string | null;
    email: string;
    status: StatusCandidato;
    candidatoResponsavel: CandidatoResponsavelResponse | null;
    duplicidade: boolean;
}

interface CandidatoEditalResponse {
    id: string;
    inscricao: string;
    candidatoId: string;
    editalId: string;
    nomeEdital: string;
}

interface CandidatoResponsavelResponse {
    id: string;
    nome: string;
    nomeSocial: string | null;
    cpf: string;
    passaporte: string | null;
    email: string;
}

interface ConfirmacaoEnvioModalProps {
    show: boolean;
    handleClose: () => void;
    handleConfirm: () => void;
    processo: Processo | null;
    candidatosSelecionados: CandidatoOnlyResponse[];
    enviarParaTodos?: boolean;
    totalElements?: number;
    dataSelecionada?: string;
    datasBancas?: any[];
}

const ConfirmacaoEnvioModal: React.FC<ConfirmacaoEnvioModalProps> = ({ show, handleClose, handleConfirm, processo, candidatosSelecionados, enviarParaTodos = false, totalElements = 0, dataSelecionada, datasBancas = [] }) => {
    const dataBancaSelecionada = dataSelecionada && datasBancas.find(d => d.id === dataSelecionada);
    
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar Envio de Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <span style={{
                        display: 'inline-block',
                        border: '1px solid #333',
                        padding: '4px 8px',
                        margin: '0 5px',
                        borderRadius: '4px',
                        fontWeight: 'bold'
                    }}>
                        {enviarParaTodos ? totalElements : candidatosSelecionados.length}
                    </span>
                    candidato(s) {enviarParaTodos ? 'do processo' : 'selecionado(s)'} receberão o email para heteroidentificação, do edital
                    <strong> {processo?.nome}</strong>.
                </p>
                {dataBancaSelecionada && (
                    <div style={{
                        marginTop: '15px',
                        padding: '12px',
                        backgroundColor: '#d1ecf1',
                        borderLeft: '4px solid #0c5460',
                        borderRadius: '4px'
                    }}>
                        <strong style={{ color: '#0c5460' }}>📅 Data da Banca:</strong>
                        <div style={{ marginTop: '5px', color: '#0c5460' }}>
                            {dataBancaSelecionada.data.split('-').reverse().join('/')} - {dataBancaSelecionada.horaInicial} às {dataBancaSelecionada.horaFinal}
                        </div>
                    </div>
                )}
                {!dataBancaSelecionada && (
                    <div style={{
                        marginTop: '15px',
                        padding: '12px',
                        backgroundColor: '#fff3cd',
                        borderLeft: '4px solid #856404',
                        borderRadius: '4px'
                    }}>
                        <strong style={{ color: '#856404' }}>⚠️ Atenção:</strong>
                        <div style={{ marginTop: '5px', color: '#856404' }}>
                            Nenhuma data de banca foi selecionada. O email será enviado sem informação de data específica.
                        </div>
                    </div>
                )}
                <p style={{ marginTop: '15px' }}>Deseja continuar?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="success" onClick={handleConfirm}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmacaoEnvioModal;
